import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

/**
 * GroupWrapper : Serve as the wrapper component for BoxGroup
 *  - Sets the WrapperClass and its style
 */
export function GroupWrapper({className, children}) {
  return <div className={className}>{children}</div>;
}

GroupWrapper.propTypes = {
  /**
   * The className to be set for wrapper
   */
  className: PropTypes.oneOf(['boxGroup-visited', 'boxGroup']),
  /**
   * The child components to be displayed inside the group
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};
